import { APIMethod, fetchData } from "@client";

export async function setAnnouncementReadStatusQuery(announcementId) {
  return await fetchData(`/announcements/${announcementId}`, APIMethod.PUT);
}
